"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAtom } from "jotai";
import { fromDataAtom } from "@/scripts/store";
import SVG from "react-inlinesvg";

export default function PageComponent({ sectionTitle, slug }: { sectionTitle: string; slug: "farmers" | "media" | "companies" | "general" }) {

  const router = useRouter();
  const subjectList = [
    { slug: "farmers", list: ["Next Green Methodについて", "Next Green Vegetablesについて", "その他"] },
    { slug: "companies", list: ["Next Green Methodについて", "Next Green Vegetablesについて", "Next Green Creditについて", "研究開発について", "その他"] },
    { slug: "media", list: ["取材のお申し込み", "Next Green Revolutionについて", "Next Green Methodについて", "Next Green Vegetablesについて", "その他"] },
    { slug: "general", list: ["プレスリリースに関するお問い合わせ", "採用情報に関するお問い合わせ", "プライバシーポリシーに関するお問い合わせ", "その他"] },
  ];
  const subjects = subjectList.find((item) => item.slug == slug).list;
  const [fromData, set_fromData]: any = useAtom(fromDataAtom);
  const onSubmit = async (e: any) => {

    
    e.preventDefault();
    const form: HTMLFormElement = e.target;

    checkValidate(form);
    const errorElement = document.querySelector(".error-message:not(:empty)");
    if (errorElement) {
      errorElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      return true;
    }

    const formData = new FormData(form);

    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });
    // console.log(formDataObject);

    set_fromData({ data: formDataObject, sectionTitle: sectionTitle });
    router.push(`/contact/${slug}/confirm/`);
  };
  // バリデート
  const checkValidate = (form) => {
    form.querySelectorAll(".contact-list-item.require").forEach((item) => {
      const errorMsgEl = item.querySelector(".error-message");
      const title = item.querySelector("h3 .text")?.textContent;
      
      // チェックボックスの分岐
      if (item.classList.contains("checkbox")) {
        const inputEls = item.querySelectorAll("input");
        const isValud = Array.from(inputEls).find((item: HTMLInputElement) => item.checked);
        if (isValud) {
          errorMsgEl.textContent = "";
        } else {
          if(title){
            errorMsgEl.textContent = `${title}を選択してください`;
          }else{
            errorMsgEl.textContent = `「個人情報保護方針に同意する」は必須項目です`;
          }
        }
      // selectの分岐
      } else if (item.classList.contains("select")) {
        const inputEl = item.querySelector("select");
        const isValud = inputEl.checkValidity()
        if (isValud) {
          errorMsgEl.textContent = "";
        } else {
          errorMsgEl.textContent = `${title}を選択してください`;
        }
      // input、textarea
      } else {
        const inputEl = item.querySelector("input,textarea");
        const isValud = inputEl.checkValidity();
        if (inputEl.name == "email_confirm" && form.querySelector('input[name="email"]').value != inputEl.value) {
          errorMsgEl.textContent = "メールアドレスが一致しておりません。";
        } else if (isValud) {
          errorMsgEl.textContent = "";
        } else {
          if(inputEl.value) {
            errorMsgEl.textContent = inputEl.validationMessage;
          } else {
            errorMsgEl.textContent = `${title}を入力してください`;
          }
        }
      }
    });
  };

  return (
    <main className="page page-contact">
      <div className="container-s">
        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="shoulder">お問い合わせ</span>
            <span className="title en">Contact</span>
          </h1>
        </div>

        <section className="section-contact">
          <div className="section-contact-title">
            <div className="title bold">{sectionTitle}</div>
            <div className="text-annotation">*は必須項目です</div>
          </div>

          <form onSubmit={onSubmit} noValidate>
            <ul className="contact-list">
              <li className="contact-list-item require select">
                <h3>
                  <span className="text">お問い合わせ要件</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <select className="custom-select" name="subject" defaultValue={fromData?.data?.subject ?? ""} required>
                      <option value="" hidden disabled>
                        お問い合わせ要件を選択してください
                      </option>
                      {subjects.map((value, i) => (
                        <option key={i} value={value}>
                          {`${i + 1}. ${value}`}
                        </option>
                      ))}
                    </select>
                    <i className="icon-select">
                      <SVG src="/assets/img/common/icon/icon-arrow-select.svg" />
                    </i>
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <li className="contact-list-item require">
                <h3>
                  <span className="text">お名前</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="name" type="text" placeholder="お名前を入力してください" defaultValue={fromData?.data?.name ?? ""} required />
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <li className="contact-list-item require">
                <h3>
                  <span className="text">会社名・屋号</span>
                  <span className="annotation">（個人の場合は個人名を入力）</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="company_name" placeholder="会社名・屋号を入力してください" type="text" defaultValue={fromData?.data?.company_name ?? ""} required />
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <li className="contact-list-item require">
                <h3>
                  <span className="text">部署名・役職</span>
                  <span className="annotation">（個人の場合は「個人」と入力）</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="position" placeholder="部署名・役職を入力してください" defaultValue={fromData?.data?.position ?? ""} type="text" required />
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <li className="contact-list-item">
                <h3>
                  <span className="text">ウェブサイトURL</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="website" placeholder="サイトURLを入力してください" defaultValue={fromData?.data?.website ?? ""} type="text" />
                  </div>
                </label>
              </li>

              <li className="contact-list-item require">
                <h3>
                  <span className="text">メールアドレス</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="email" type="email" placeholder="メールアドレスを入力してください" defaultValue={fromData?.data?.email ?? ""} required />
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <li className="contact-list-item require">
                <h3>
                  <span className="text">メールアドレス（確認用）</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <input name="email_confirm" type="email" placeholder="メールアドレス（確認用）を入力してください" defaultValue={fromData?.data?.email_confirm ?? ""} required />
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              {slug == "farmers" && (
                <>
                  <li className="contact-list-item">
                    <h3>
                      <span className="text">電話番号（携帯）</span>
                    </h3>
                    <label className="label-block">
                      <div className="input-holder">
                        <input name="tel" type="number" placeholder="012354678（半角英数字、ハイフン除く）" defaultValue={fromData?.data?.tel ?? ""} />
                      </div>
                    </label>
                  </li>

                  <li className="contact-list-item require">
                    <h3>
                      <span className="text">所在地(市区町村)</span>
                      <span className="require">*</span>
                    </h3>
                    <label className="label-block">
                      <div className="input-holder">
                        <input name="address" type="text" placeholder="例 : 北海道帯広市" defaultValue={fromData?.data?.address ?? ""} required />
                      </div>
                    </label>
                    <div className="error-message"></div>
                  </li>

                  <li className="contact-list-item">
                    <h3>
                      <span className="text">栽培管理面積</span>
                    </h3>
                    <label className="label-block">
                      <div className="input-holder">
                        <input name="cultivation_area" type="text" placeholder="例 : 約990㎡" defaultValue={fromData?.data?.cultivation_area ?? ""} required />
                      </div>
                    </label>
                  </li>

                  <li className="contact-list-item require checkbox">
                    <h3>
                      <span className="text">農法</span>
                      <span className="require">*</span>
                    </h3>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_1" defaultChecked={fromData?.data?.farming_method_1 != null} value="慣行農業" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">慣行農業</div>
                    </label>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_2" defaultChecked={fromData?.data?.farming_method_2 != null} value="特別栽培" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">特別栽培</div>
                    </label>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_3" defaultChecked={fromData?.data?.farming_method_3 != null} value="有機相当" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">有機相当</div>
                    </label>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_4" defaultChecked={fromData?.data?.farming_method_4 != null} value="有機農業" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">有機農業</div>
                    </label>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_5" defaultChecked={fromData?.data?.farming_method_5 != null} value="自然栽培" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">自然栽培</div>
                    </label>
                    <label className="label-block">
                      <div className="input-holder">
                        <input type="checkbox" name="farming_method_6" defaultChecked={fromData?.data?.farming_method_6 != null} value="その他" />
                        <i className="icon-checkbox">
                          <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                        </i>
                      </div>
                      <div className="text-checkbox">その他</div>
                    </label>
                    <div className="error-message"></div>
                  </li>

                  <li className="contact-list-item">
                    <h3>
                      <span className="text">栽培作物</span>
                    </h3>
                    <label className="label-block">
                      <div className="input-holder">
                        <input name="cultivated_crops" placeholder="栽培作物の内容を入力してください" defaultValue={fromData?.data?.cultivated_crops ?? ""} type="text" />
                      </div>
                    </label>
                  </li>
                </>
              )}

              <li className="contact-list-item require">
                <h3>
                  <span className="text">お問い合わせ内容</span>
                  <span className="require">*</span>
                </h3>
                <label className="label-block">
                  <div className="input-holder">
                    <textarea name="message" placeholder="お問い合わせ内容" defaultValue={fromData?.data?.message ?? ""} required></textarea>
                  </div>
                </label>
                <div className="error-message"></div>
              </li>

              <div className="policy contact-list-item require checkbox">
                <label className="label-block">
                  <div className="input-holder">
                    <input type="checkbox" name="policy" defaultChecked={fromData?.data?.policy != null} value="同意する" />
                    <i className="icon-checkbox">
                      <SVG src="/assets/img/common/icon/icon-checkbox.svg" />
                    </i>
                  </div>
                  <div className="text-checkbox">
                    <a href="/privacy-policy/" target="_blank">
                      個人情報保護方針
                    </a>
                    に同意する
                  </div>
                </label>
                <div className="error-message"></div>
              </div>
              
            </ul>

            <div className="button-holder">
              <button className="button-round scaleHover" type="submit">
                <span className="inner">入力内容を確認する</span>
              </button>
            </div>
          </form>
        </section>
      </div>
    </main>
  );
}
